import ApplicationForm from '@/components/forms/ApplicationForm';

export default function Performers() {
  return (
    <ApplicationForm
      applicationType="performers"
      title="Performers"
      description="Bring the forest to life! We're looking for fire performers, dancers, 
        circus artists, stilt walkers, roving performers, and all manner of creative entertainers 
        to enchant our guests."
      showPortfolio={true}
      showExperience={true}
      showRequirements={true}
      showInsurance={true}
      showCertificates={true}
    />
  );
}
